export const timeZoneMapping: Record<string, string> = {
  // Pacific Time Zone
  PST: 'America/Los_Angeles', // Pacific Standard Time (UTC-8)
  PDT: 'America/Los_Angeles', // Pacific Daylight Time (UTC-7)

  // Mountain Time Zone
  MT: 'America/Denver', // Mountain Time (UTC-7/-6, observes DST) — matches Athena label
  MST: 'America/Denver', // kept for backward compatibility with stored data
  MDT: 'America/Denver', // Mountain Daylight Time (UTC-6)
  MST_AZ: 'America/Phoenix', // Arizona (does not observe daylight saving time)
  MST_STATIC: 'America/Phoenix', // Static MST (always UTC-7, no DST) - for when user wants true MST

  // Central Time Zone
  CST: 'America/Chicago', // Central Standard Time (UTC-6)
  CDT: 'America/Chicago', // Central Daylight Time (UTC-5)

  // Eastern Time Zone
  EST: 'America/New_York', // Eastern Standard Time (UTC-5)
  EDT: 'America/New_York', // Eastern Daylight Time (UTC-4)

  // Alaska Time Zone
  AKT: 'America/Anchorage', // Generic Alaska Time
  AKST: 'America/Anchorage', // Alaska Standard Time (UTC-9)
  AKDT: 'America/Anchorage', // Alaska Daylight Time (UTC-8)

  // Hawaii-Aleutian Time Zone
  HST: 'Pacific/Honolulu', // Hawaii Standard Time (UTC-10) (No DST)
  HADT: 'America/Adak', // Hawaii-Aleutian Daylight Time (UTC-9)

  // Atlantic Time Zone (Puerto Rico, US Virgin Islands)
  AST: 'America/Puerto_Rico', // Atlantic Standard Time (UTC-4)
  ADT: 'America/Puerto_Rico', // Atlantic Daylight Time (UTC-3) (rarely used)

  // Samoa Time Zone
  SST: 'Pacific/Pago_Pago', // Samoa Standard Time (UTC-11)
  SDT: 'Pacific/Pago_Pago', // Samoa Daylight Time (UTC-10) (rarely used)

  // Chamorro Time Zone (Guam, Northern Mariana Islands)
  ChST: 'Pacific/Guam', // Chamorro Standard Time (UTC+10)

};
